(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function measure(root) {
      var card = root.querySelector('.swiper-slide article');
      var banners = root.querySelectorAll('[data-mj-fc-banner]');
      if (!banners.length) return;
      var height = card ? card.offsetHeight : 0;
      banners.forEach(function (banner) {
        if (height > 0) {
          banner.style.height = height + 'px';
        } else {
          banner.style.height = '';
        }
      });
    }

    function bind(root) {
      if (!root || root.dataset.mjFcBannerBound === '1') return;
      var card = root.querySelector('.swiper-slide article');
      if (!card) {
        measure(root);
        return;
      }
      root.dataset.mjFcBannerBound = '1';
      measure(root);
      if (typeof ResizeObserver === 'undefined') {
        window.addEventListener('resize', function () {
          measure(root);
        });
        return;
      }
      var observer = new ResizeObserver(function () {
        measure(root);
      });
      observer.observe(card);
    }

    function scan(scope) {
      var context = scope && scope.querySelectorAll ? scope : document;
      context.querySelectorAll('[data-mj-fc-banners]').forEach(bind);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        scan();
      });
    } else {
      scan();
    }

    document.addEventListener('shopify:section:load', function (event) {
      scan(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-descuento-progreso"] && !Shopify.designMode) return;
  try {
    
class HomeDescuentoProgreso extends HTMLElement {
  connectedCallback() {
    this.msgEl = this.querySelector('[data-progress-msg]');
    this.fillEl = this.querySelector('[data-progress-fill]');
    this.trackEl = this.querySelector('[data-progress-track]');
    this.tiers = [
      { min: parseFloat(this.dataset.tierShipping) || 99990, shipping: true },
      { min: parseFloat(this.dataset.tier10) || 150000, percent: 10 },
      { min: parseFloat(this.dataset.tier15) || 400000, percent: 15 },
      { min: parseFloat(this.dataset.tier20) || 1000000, percent: 20 },
    ];
    this.locale = this.dataset.locale || 'es-CL';
    this.currency = this.dataset.currency || 'CLP';
    this.msgAdd = this.dataset.msgAdd || 'Agrega __AMOUNT__ para obtener __PERCENT__%';
    this.msgShipping = this.dataset.msgShipping || 'Agrega __AMOUNT__ para obtener envío gratis';
    this.msgDone = this.dataset.msgDone || 'Ya tienes el __PERCENT__% de descuento';
    this.sectionEl = this.closest('.shopify-section');
    this.headerEl = document.querySelector('.section-header');
    this.onPin = () => this.solicitarPin();
    this.escucharCarrito();
    this.escucharScroll();
    this.refresh();
    this.pin();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onPin);
    window.removeEventListener('resize', this.onPin);
    this.headerMo?.disconnect();
  }

  escucharScroll() {
    window.addEventListener('scroll', this.onPin, { passive: true });
    window.addEventListener('resize', this.onPin);
    if (this.headerEl) {
      this.headerMo = new MutationObserver(() => this.animarPin());
      this.headerMo.observe(this.headerEl, { attributes: true, attributeFilter: ['class', 'style'] });
    }
  }

  solicitarPin() {
    if (this._pinRaf) return;
    this._pinRaf = requestAnimationFrame(() => {
      this._pinRaf = 0;
      this.pin();
    });
  }

  animarPin() {
    const inicio = performance.now();
    const tick = (ahora) => {
      this.pin();
      if (ahora - inicio < 220) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  pin() {
    if (!this.sectionEl) return;
    const headerBottom = this.headerEl
      ? Math.max(0, Math.round(this.headerEl.getBoundingClientRect().bottom))
      : 0;
    this.sectionEl.style.top = `${headerBottom}px`;
    const top = Math.round(this.sectionEl.getBoundingClientRect().top);
    this.sectionEl.classList.toggle('is-stuck', top <= headerBottom + 1);
  }

  money(v) {
    return new Intl.NumberFormat(this.locale, {
      style: 'currency',
      currency: this.currency,
      maximumFractionDigits: 0,
    }).format(v);
  }

  estado(total) {
    const last = this.tiers[this.tiers.length - 1];
    if (total >= last.min) {
      return { done: true, shipping: false, percent: last.percent, needed: 0, progress: 100, threshold: last.min };
    }
    const next = this.tiers.find((t) => total < t.min) || last;
    const progress = next.min > 0 ? Math.min(100, (total / next.min) * 100) : 0;
    return {
      done: false,
      shipping: Boolean(next.shipping),
      percent: next.percent || 0,
      needed: Math.max(0, next.min - total),
      progress,
      threshold: next.min,
    };
  }

  render(total) {
    const s = this.estado(total);
    if (this.msgEl) {
      const token = (name) => '{' + '{ ' + name + ' }' + '}';
      const amount = this.money(s.needed);
      if (s.done) {
        this.msgEl.textContent = this.msgDone
          .replace(token('percent'), String(s.percent))
          .replace('__PERCENT__', String(s.percent));
      } else if (s.shipping) {
        this.msgEl.textContent = this.msgShipping.replace(token('amount'), amount).replace('__AMOUNT__', amount);
      } else {
        this.msgEl.textContent = this.msgAdd
          .replace(token('amount'), amount)
          .replace(token('percent'), String(s.percent))
          .replace('__AMOUNT__', amount)
          .replace('__PERCENT__', String(s.percent));
      }
    }
    if (this.fillEl) this.fillEl.style.width = `${s.progress}%`;
    if (this.trackEl) this.trackEl.setAttribute('aria-valuenow', String(Math.round(s.progress)));
  }

  escucharCarrito() {
    if (!window.__mjCartFetchPatched) {
      const originalFetch = window.fetch;
      window.fetch = async (...args) => {
        const res = await originalFetch(...args);
        try {
          const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
          if (/\/cart\/(add|change|update|clear)/.test(url)) {
            document.dispatchEvent(new CustomEvent('mj:cart-changed'));
          }
        } catch (_) {}
        return res;
      };
      window.__mjCartFetchPatched = true;
    }

    document.addEventListener('mj:cart-changed', () => this.refreshDebounced());
    document.addEventListener('calc-rent:cart-changed', () => this.refreshDebounced());
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => this.refreshDebounced());
    }
  }

  refreshDebounced() {
    clearTimeout(this._t);
    this._t = setTimeout(() => this.refresh(), 200);
  }

  async refresh() {
    try {
      const root = window.Shopify?.routes?.root || '/';
      const cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();
      this.render((cart.items_subtotal_price || cart.total_price || 0) / 100);
    } catch (_) {}
  }
}

if (!customElements.get('home-descuento-progreso')) {
  customElements.define('home-descuento-progreso', HomeDescuentoProgreso);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["huincha-movil"] && !Shopify.designMode) return;
  try {
    
  class HuinchaMovil extends HTMLElement {
    connectedCallback() {
      this.timerEl = this.querySelector('[data-timer]');
      this.expiredEl = this.querySelector('[data-expired]');
      if (!this.timerEl || !this.dataset.end) return;

      this.end = Date.parse(this.dataset.end);
      if (Number.isNaN(this.end)) return;

      this.showDays = this.dataset.showDays === 'true';
      this.hideExpired = this.dataset.hideExpired === 'true';
      this.units = {};
      this.timerEl.querySelectorAll('[data-unit]').forEach((el) => {
        this.units[el.dataset.unit] = el;
      });

      this.actualizar();
      this.intervalo = setInterval(() => this.actualizar(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.intervalo);
    }

    actualizar() {
      const restante = Math.floor((this.end - Date.now()) / 1000);

      if (restante <= 0) {
        this.pintar(0);
        this.expirar();
        return;
      }

      this.pintar(restante);
    }

    pintar(restante) {
      const dias = this.showDays ? Math.floor(restante / 86400) : 0;
      const horas = this.showDays ? Math.floor((restante % 86400) / 3600) : Math.floor(restante / 3600);

      this.escribir('days', dias);
      this.escribir('hours', horas);
      this.escribir('minutes', Math.floor((restante % 3600) / 60));
      this.escribir('seconds', restante % 60);
    }

    escribir(unidad, valor) {
      const el = this.units[unidad];
      if (!el) return;
      const texto = String(valor).padStart(2, '0');
      if (el.textContent !== texto) el.textContent = texto;
    }

    expirar() {
      clearInterval(this.intervalo);

      // En el editor de temas dejamos la huincha visible para poder seguir configurándola.
      if (this.hideExpired && !window.Shopify?.designMode) {
        const seccion = this.closest('.shopify-section');
        if (seccion) seccion.hidden = true;
        else this.hidden = true;
        return;
      }

      this.timerEl.hidden = true;
      if (this.expiredEl) this.expiredEl.hidden = false;
    }
  }

  if (!customElements.get('huincha-movil')) {
    customElements.define('huincha-movil', HuinchaMovil);
  }

  } catch(e) { console.error(e); }
})();
})();
